import { CommonError, LeadOrCustomerWithIndex } from '@types'
import React, { useCallback, useEffect, useState } from 'react'
import { message, Popover, Spin, Tooltip } from 'antd'

interface HiddenTextProps<F> {
  name: string // popover的高亮信息
  keyWord: string // res中返回的关键字段
  filter: F
  service: (filter: F) => Promise<[null, CommonError] | [object, null]>
  disableTooltip?: boolean // 是否禁用悬浮提示
}

function HiddenText<F = LeadOrCustomerWithIndex> (props: React.PropsWithChildren<HiddenTextProps<F>>) {
  const {
    filter,
    service = () => Promise.resolve([null, null]),
    keyWord = '',
    name,
    children,
    disableTooltip = false
  } = props

  const [plaintext, setPlaintext] = useState(undefined)
  const [loading, setLoading] = useState(false)

  const onOpenChange = useCallback(async (open: boolean) => {
    if (open && !plaintext) {
      setLoading(true)
      const [res, err] = await service(filter)
      if (err) {
        message.error(`获取${name}失败: ${err.message}`)
        setLoading(false)
        return
      }
      setLoading(false)
      setPlaintext(res?.[keyWord])
      message.warning('本次资料查询操作已记录，请勿外泄')
    } else if (open && plaintext) {
      message.warning('本次资料查询操作已记录，请勿外泄')
    }
  }, [filter, plaintext, name, keyWord])

  // 当children变化的时候去除缓存
  useEffect(() => setPlaintext(undefined), [children])

  return (
    <Popover
      placement="top"
      trigger="click"
      onOpenChange={onOpenChange}
      content={<Spin spinning={loading}>{plaintext}</Spin>}
    >
      {disableTooltip ? (
        <span style={{ cursor: 'pointer', color: 'dodgerblue' }}>{children}</span>
      ) : (
        <Tooltip
          title={
            <div style={{ whiteSpace: 'pre-line' }}>
              {`查看${name}，操作会被记录，请勿外泄`}
            </div>
          }
          placement="bottom"
        >
          <span style={{ cursor: 'pointer', color: 'dodgerblue' }}>{children}</span>
        </Tooltip>
      )}
    </Popover>
  )
}

export default React.memo(HiddenText) as typeof HiddenText
